import { render, staticRenderFns } from "./projectDes.vue?vue&type=template&id=2eea48d0&"
import script from "./projectDes.vue?vue&type=script&lang=js&"
export * from "./projectDes.vue?vue&type=script&lang=js&"
import style0 from "./projectDes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports